var _path, _rect, _rect2, _circle, _circle2, _rect3, _circle3, _circle4, _rect4, _circle5, _circle6, _circle7, _circle8, _rect5, _circle9, _circle10, _rect6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon, _path17, _polygon2, _polygon3, _path18, _polygon4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle11, _path26, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 458.08828,
    height: 598.16298,
    viewBox: "0 0 458.08828 598.16298",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.31,69.84738H22.69A22.71737,22.71737,0,0,0,0,92.53738v158.62a22.71737,22.71737,0,0,0,22.69,22.69H301.31a22.71738,22.71738,0,0,0,22.69-22.69v-158.62A22.71737,22.71737,0,0,0,301.31,69.84738Zm20.69,181.31a20.69,20.69,0,0,1-20.69,20.69H22.69A20.69,20.69,0,0,1,2,251.15736V227.52292A155.67554,155.67554,0,0,1,157.67554,71.84738H301.31a20.69,20.69,0,0,1,20.69,20.69Z",
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.71875,
    y: 155.06369,
    width: 121.85303,
    height: 2,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.93311,
    y: 176.27658,
    width: 196.53558,
    height: 2,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 155.84738,
    r: 8,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 155.84738,
    r: 8,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.71875,
    y: 197.06369,
    width: 121.85303,
    height: 2,
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 197.84738,
    r: 8,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 197.84738,
    r: 8,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.71875,
    y: 218.06369,
    width: 121.85303,
    height: 2,
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 218.84738,
    r: 8,
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 218.84738,
    r: 8,
    fill: "#e6e6e6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 176.84738,
    r: 8,
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.46869,
    cy: 176.82027,
    r: 8,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49.93311,
    y: 239.27658,
    width: 196.53558,
    height: 2,
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 239.84738,
    r: 8,
    fill: "#e6e6e6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.46869,
    cy: 239.82027,
    r: 8,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 248.16554,
    y: 89.51711,
    width: 50.60631,
    height: 50.6063,
    rx: 7.43701,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.188,95.82027h7.84369a7.437,7.437,0,0,1,7.437,7.437v23.126a7.437,7.437,0,0,1-7.437,7.437h-23.126a7.437,7.437,0,0,1-7.437-7.437v-7.84368A22.7193,22.7193,0,0,1,277.188,95.82027Z",
    fill: "#076eab"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M271.96869,88.32027a2.12132,2.12132,0,0,0,0,3,2.09846,2.09846,0,0,0,.5.35986V96.7773h2V91.68013a2.09846,2.09846,0,0,0,.5-.35986,2.12132,2.12132,0,0,0-3-3Z",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.96869,88.32027a2.12132,2.12132,0,0,0,0,3,2.09846,2.09846,0,0,0,.5.35986V96.7773h2V91.68013a2.09846,2.09846,0,0,0,.5-.35986,2.12132,2.12132,0,0,0-3-3Z",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.96869,88.32027a2.12132,2.12132,0,0,0,0,3,2.09846,2.09846,0,0,0,.5.35986V96.7773h2V91.68013a2.09846,2.09846,0,0,0,.5-.35986,2.12132,2.12132,0,0,0-3-3Z",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.46869,137.7961v-5.09717h-2v5.09717a2.09818,2.09818,0,0,0-.5.35986,2.12132,2.12132,0,1,0,3,0A2.09818,2.09818,0,0,0,274.46869,137.7961Z",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M269.46869,137.7961v-5.09717h-2v5.09717a2.09818,2.09818,0,0,0-.5.35986,2.12132,2.12132,0,1,0,3,0A2.09818,2.09818,0,0,0,269.46869,137.7961Z",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.46869,137.7961v-5.09717h-2v5.09717a2.09818,2.09818,0,0,0-.5.35986,2.12132,2.12132,0,1,0,3,0A2.09818,2.09818,0,0,0,264.46869,137.7961Z",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M296.38654,106.7381a2.12132,2.12132,0,1,0,0-3,2.09842,2.09842,0,0,0-.35987.5H290.9295v2h5.09717A2.098,2.098,0,0,0,296.38654,106.7381Z",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M296.38654,108.7381a2.09842,2.09842,0,0,0-.35987.5H290.9295v2h5.09717a2.098,2.098,0,0,0,.35987.5,2.12132,2.12132,0,1,0,0-3Z",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M296.38654,113.7381a2.09842,2.09842,0,0,0-.35987.5H290.9295v2h5.09717a2.098,2.098,0,0,0,.35987.5,2.12132,2.12132,0,1,0,0-3Z",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M296.38654,118.7381a2.09842,2.09842,0,0,0-.35987.5H290.9295v2h5.09717a2.098,2.098,0,0,0,.35987.5,2.12132,2.12132,0,1,0,0-3Z",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M296.38654,123.7381a2.09842,2.09842,0,0,0-.35987.5H290.9295v2h5.09717a2.098,2.098,0,0,0,.35987.5,2.12132,2.12132,0,1,0,0-3Z",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250.55086,123.7381a2.12132,2.12132,0,1,0,0,3,2.098,2.098,0,0,0,.35986-.5h5.09718v-2h-5.09716a2.09842,2.09842,0,0,0-.35987-.5Z",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250.55086,118.7381a2.12132,2.12132,0,1,0,0,3,2.098,2.098,0,0,0,.35986-.5h5.09718v-2h-5.09716a2.09842,2.09842,0,0,0-.35987-.5Z",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M429.40173,105.45029,404.00232,222.54015l4.46973,31.25c11.25976,10.67968,1.61575,63.09893-6.88425,73.58917,0,0-18.96634-45.33917-47.04642-45.679-7.88965-.09082-15.59961.05957-22.39941.62012a84.13838,84.13838,0,0,0-14.49024,2.22949c-26,7-22.64941-2.00976-22.64941-2.00976l20.96973-162.82032,15.79-16.26953L344.4115,90.42l5.75-14.21,39.56055-3.38965,6.33007,14.8291L409.71228,89.67l9.76953,1.43945A11.94271,11.94271,0,0,1,429.40173,105.45029Z",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "409.712 89.67 394.375 107.165 389.588 108.379 388.406 113.974 354.772 152.34 338.665 118.117 333.588 115.379 334.957 110.238 331.762 103.45 335.588 97.379 340.588 92.379 344.411 90.42 350.161 76.21 389.722 72.82 396.052 87.65 402.588 86.379 409.712 89.67",
    fill: "#076eab"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M275.91107,305.67512l9.4003-28.52874,17.04648,3.09619L291.346,310.05131a10.05533,10.05533,0,1,1-15.435-4.37616Z",
    fill: "#ffb6b6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "323.849 117.695 315.973 119.72 296.159 210.353 291.87 214.642 293.648 218.546 291.87 225.412 278.799 290.601 307.743 302.126 337.223 167.585 323.849 117.695",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "368.536 582.386 355.209 582.385 348.869 530.98 368.539 530.981 368.536 582.386",
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M369.00516,596.28865l-40.98249-.00159v-.51825a15.95243,15.95243,0,0,1,15.95151-15.95129h.001l7.486-5.6792,13.96716,5.68011,3.57752.00007-.00067,16.47009Z",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "295.536 582.386 282.209 582.385 275.869 530.98 295.539 530.981 295.536 582.386",
    fill: "#ffb6b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M296.00516,596.28865l-40.98249-.00159v-.51825a15.95243,15.95243,0,0,1,15.95151-15.95129h.001l7.486-5.6792,13.96716,5.68011,3.57752.00007-.00067,16.47009Z",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M403.82938,580.83a2.26936,2.26936,0,0,0,1.64468-3.93335l-.15549-.61816q.03072-.07425.06177-.14838a6.09416,6.09416,0,0,1,11.24139.04175c1.8386,4.42816,4.17942,8.86389,4.7558,13.546a18.02944,18.02944,0,0,1-.31646,6.2005,72.28141,72.28141,0,0,0,6.57516-30.02075,69.7669,69.7669,0,0,0-.43274-7.783q-.35852-3.17779-.99472-6.31037a73.11887,73.11887,0,0,0-14.50012-30.98962,19.45882,19.45882,0,0,1-8.093-8.39654,14.84311,14.84311,0,0,1-1.34991-4.05619c.394.05167,1.48556-5.94867,1.18841-6.3168.54908-.83316,1.53177-1.24735,2.13144-2.06033,2.98233-4.0434,7.09119-3.33741,9.23621,2.15725,4.58224,2.31266,4.62659,6.14807,1.81494,9.83683-1.78879,2.34683-2.03455,5.5223-3.60407,8.03476.1615.20672.32944.40692.49091.61364a73.58778,73.58778,0,0,1,7.681,12.16858,30.59224,30.59224,0,0,1,1.82642-14.20959c1.7482-4.21735,5.0249-7.76917,7.91046-11.415a6.27923,6.27923,0,0,1,11.184,3.08331q.00888.08061.0173.1612-.64288.36269-1.25863.76992a3.07821,3.07821,0,0,0,1.241,5.60175l.06278.00964a30.62571,30.62571,0,0,1-.80734,4.57935c3.70178,14.31579-4.2901,19.52991-15.70148,19.7641-.25192.12915-.49738.2583-.7493.3811a75.11332,75.11332,0,0,1,4.04325,19.02777,71.24472,71.24472,0,0,1-.05167,11.50324l.01938-.13562a18.82606,18.82606,0,0,1,6.4266-10.8703c4.94562-4.06263,11.93283-5.55872,17.26825-8.82428a3.53305,3.53305,0,0,1,5.41123,3.43707l-.02182.14264a20.6795,20.6795,0,0,0-2.3187,1.11731q-.64289.36273-1.25864.7699a3.07824,3.07824,0,0,0,1.24106,5.6018l.06281.00965c.0452.00647.084.01294.12912.01947a30.65486,30.65486,0,0,1-5.63855,8.82922c-2.31464,12.49713-12.256,13.6828-22.89023,10.04352h-.00647a75.09108,75.09108,0,0,1-5.0444,14.72619H404.28094c-.06463-.20019-.12274-.40692-.18087-.60717a20.47772,20.47772,0,0,0,4.98629-.297c-1.337-1.64056-2.67395-3.29407-4.011-4.93463a1.12112,1.12112,0,0,1-.084-.09687c-.67816-.83959-1.36282-1.67285-2.041-2.51245l-.00037-.001a29.98984,29.98984,0,0,1,.87876-7.63984l.00058-.00036Z",
    fill: "#f2f2f2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M202.278,596.973a1.18647,1.18647,0,0,0,1.19006,1.19h253.29a1.19,1.19,0,0,0,0-2.38h-253.29A1.18651,1.18651,0,0,0,202.278,596.973Z",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M402.25281,264.62489,298.5166,269.59755l-28,128.48212,8,21.03741-11.29816,9.98614,11.29816,14.01386-2.91226,72.58075-6.83249,17.64209,5.234,22.19641,23.766-1.19641L318.8606,441.42238l-3.27277-13.04306,7.84418-11.43405,9.45273-50.61365,6.70309,49.04767-1.15552,21.8345,6.15552,23.1655,3.418,99.157,23.46457.3028,5.04639-9.95636-5.511-13.34644,5.511-9.33069s17.51095-82.88977,8-100.77954l16.2297-89.56723-1.97461-13.519,6.44086-11.129,8.27344-45.65884-11.23334-1.92719Z",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M308.42871,117.66741l27.03479,13.09106-5.32361,16.48721L302.0495,132.388a10.05533,10.05533,0,1,1,6.37924-14.72058Z",
    fill: "#ffb6b6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M391.35492,192.39015a16.49829,16.49829,0,0,1-7.7442-8.788l-68.83887-34.26224,12.77808-28.46748,61.22192,28.46748,19.49429-56.53049,3.76072.71051a17.7931,17.7931,0,0,1,14.25842,20.34482l-10.86243,66.67644a16.53929,16.53929,0,0,1-24.0679,11.84892Z",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M354.54135,281.7003c-8.3327,8.53848-15.90912,6.08826-22.39941.62012l13.46-21.18067Z",
    fill: "#076eab"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.70093,
    cy: 41.32395,
    r: 28.66645,
    fill: "#ffb6b6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M398.80212,53.2999a8.10693,8.10693,0,0,0-3.7998-2c1.55957.84961,1.75976,2.78027,1.72949,4.74023,0,.35938-.01953.71-.03027,1.05957a27.69963,27.69963,0,0,1-7.38965,7.58009s-9.61035,3.61035-14.34961,4.00977c2.47949-3.58984,5.96973-10.00977,8.44922-13.58984a21.2539,21.2539,0,0,0,3.25-5.99023,7.16989,7.16989,0,0,0-1-6.50977,5.27121,5.27121,0,0,0-9.30957,3.65039c-1.75977-.73047-.38867-3.59863-1.69043-5.00977-1.96973-2.13574-2.26074-4.16211.73047-5.63086,1.667-.81836-2.12012-3.10938-3.91992-3.62988a12.82448,12.82448,0,0,0-5.54981-.06934c-5.29.80957-10.46,2.64941-15.82031,2.5498a18.07347,18.07347,0,0,1-3.2002-.35059,13.51813,13.51813,0,0,0-.03027-9.00977,23.19065,23.19065,0,0,1-4.89941,7.06055,9.874,9.874,0,0,1-4.5958-5.77543l.006-.01465q.36846-.20481.71985-.4258a1.91778,1.91778,0,0,0-.87137-3.50864l-.05847-.00594a13.6105,13.6105,0,0,1,1.29981-4.12012,18.956,18.956,0,0,1,2.08007-3.25977,11.13354,11.13354,0,0,0,2.30957-.01953l.05069-.00461a1.67267,1.67267,0,0,0,.57526-3.14283q-.08322-.046-.166-.09281l-.001-.00634c1.5253-1.62392,3.14264-3.32572,5.27151-4.00341,2.0293-.64062,4.62989-.03027,5.55957,1.89941,5.19043-5.62012,14.07032-13.59961,18.85059-7.46973,4.85059,6.23407,13.87973,4.42114,19.80963,11.94981l-.00006.00037a13.026,13.026,0,0,0-3.77051,3.31934,22.08281,22.08281,0,0,1,5.68067-.12012,6.00707,6.00707,0,0,1,.06933,5.40039c1.7207,1.69043,5.16016,4.71,2.90039,5.16992a27.9087,27.9087,0,0,1,1.11035,25.37012Z",
    fill: "#2f2e41"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.46872,
    cy: 89.51711,
    r: 8,
    fill: "#076eab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot);
export default __webpack_public_path__ + "static/media/iot.4313eeace79e657bbcd764dbe9bf89f0.svg";
export { ForwardRef as ReactComponent };